export default "__VITE_ASSET__e59ad8fe__"